import React from 'react';

export default ({ event }) => (
    <div className="event__panel">
        <div className="event__description">
            <strong>Own Goal!</strong>
        </div>
    </div>
);
